var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',{attrs:{"include":['InterviewList']}},[(_vm.isMobile)?_c('div',{staticClass:"mobile-tips"},[_vm._v(_vm._s('移动端暂不支持，请前往PC查看'))]):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }